(() => {
  const selectors = {
    form: 'form[data-type="add-to-cart-form"]',
    customisation: '[data-ppv2-customisation]',
    addButton: '[name="add"]',
    checkout: '[data-ppv2-checkout]',
    quantityInput: '.quantity__input',
  };

  const moneyFromPriceNode = () => {
    const price = document.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');
    return price ? price.textContent.replace(/\s+/g, ' ').trim() : '';
  };

  const getSelectedOptionValue = (optionName) => {
    if (!optionName) return '';
    const normalizedName = optionName.trim().toLowerCase();

    const fieldset = [...document.querySelectorAll('variant-selects fieldset')].find((item) => {
      const legend = item.querySelector('legend');
      return legend && legend.textContent.trim().toLowerCase() === normalizedName;
    });

    if (fieldset) {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : '';
    }

    const select = [...document.querySelectorAll('variant-selects select')].find((item) => {
      const label = document.querySelector(`label[for="${item.id}"]`);
      return label && label.textContent.trim().toLowerCase() === normalizedName;
    });

    return select ? select.value : '';
  };

  const setGroupEnabled = (group, enabled) => {
    group.classList.toggle('hidden', !enabled);
    group.querySelectorAll('input, textarea').forEach((field) => {
      field.disabled = !enabled;
    });
  };

    const normalizeCustomisationType = (type) => {
    return type === 'multiple_photos' ? 'pack_photos' : type;
  };

  const getPackSize = (root) => {
    const value = getSelectedOptionValue(root.dataset.packSizeOption || 'Pack Size');
    const match = value.match(/\d+/);
    return match ? parseInt(match[0], 10) : 1;
  };

  const updatePackPhotoFields = (root, group) => {
  const packSize = getPackSize(root);

    group.querySelectorAll('[data-pack-photo-field]').forEach((field) => {
      const fieldNumber = parseInt(field.dataset.packPhotoField, 10);
      const enabled = fieldNumber <= packSize;

      field.classList.toggle('hidden', !enabled);
      field.querySelectorAll('input, textarea').forEach((input) => {
        input.disabled = !enabled;
        if (!enabled) input.value = '';
      });

      field.querySelectorAll('[data-pack-photo-note]').forEach((note) => {
        note.hidden = fieldNumber !== packSize;
      });
    });
  };

    const getCollagePhotoCount = (root) => {
    const value = getSelectedOptionValue(root.dataset.collageSizeOption || 'Size');
    const match = value.match(/(\d+)\s*photo/i);
    return match ? parseInt(match[1], 10) : 4;
  };

  const updateCollagePhotoFields = (root, group) => {
    const photoCount = getCollagePhotoCount(root);

    group.querySelectorAll('[data-collage-photo-field]').forEach((field) => {
      const fieldNumber = parseInt(field.dataset.collagePhotoField, 10);
      const enabled = fieldNumber <= photoCount;

      field.classList.toggle('hidden', !enabled);
      field.querySelectorAll('input, textarea').forEach((input) => {
        input.disabled = !enabled;
        if (!enabled) input.value = '';
      });

      field.querySelectorAll('[data-collage-photo-note]').forEach((note) => {
        note.hidden = fieldNumber !== photoCount;
      });
    });
  };

    const updateCustomisationGroups = (root) => {
    const type = normalizeCustomisationType(root.dataset.customisationType || 'double_sided_photo');
    const printSides = getSelectedOptionValue(root.dataset.printSidesOption).toLowerCase();
    const effectiveType = type === 'double_sided_photo' && printSides === 'single' ? 'single_photo' : type;

    root.querySelectorAll('[data-ppv2-group]').forEach((group) => {
      const isActive = group.dataset.ppv2Group === effectiveType;
      setGroupEnabled(group, isActive);

      if (isActive && effectiveType === 'pack_photos') {
        updatePackPhotoFields(root, group);
      }

      if (isActive && effectiveType === 'collage_photos') {
        updateCollagePhotoFields(root, group);
      }
    });
  };

  const fieldHasValue = (field) => {
    return field.type === 'file' ? field.files.length > 0 : field.value.trim() !== '';
  };

  const groupHasValue = (group) => {
    return [...group.querySelectorAll('input:not([disabled]), textarea:not([disabled])')].some(fieldHasValue);
  };

  const getActiveGroup = (form) => {
    return form.querySelector('.ppv2-customisation [data-ppv2-group]:not(.hidden)');
  };

  const validatePersonalisation = (form) => {
    const activeGroup = getActiveGroup(form);
    if (!activeGroup) return true;

    if (activeGroup.dataset.ppv2Group !== 'double_sided_photo') {
      return groupHasValue(activeGroup);
    }

    const frontFields = activeGroup.querySelectorAll('input[name*="Front"], textarea[name*="Front"]');
    const backFields = activeGroup.querySelectorAll('input[name*="Back"], textarea[name*="Back"]');

    return [...frontFields].some(fieldHasValue) && [...backFields].some(fieldHasValue);
  };

  const showValidationMessage = (form) => {
    let message = form.querySelector('[data-ppv2-validation]');
    if (!message) {
      message = document.createElement('p');
      message.className = 'ppv2-validation-message';
      message.dataset.ppv2Validation = '';
      form.querySelector(selectors.customisation)?.appendChild(message);
    }

    const activeGroup = getActiveGroup(form);
    message.textContent = activeGroup?.dataset.ppv2Group === 'double_sided_photo'
      ? 'Please add a photo or message for both sides before creating your card.'
      : 'Please add a photo or message before creating your card.';
  };

  const hideValidationMessage = (form) => {
    form.querySelector('[data-ppv2-validation]')?.remove();
  };

  const hasPersonalisation = (form) => {
    return [...form.querySelectorAll('.ppv2-customisation input:not([disabled]), .ppv2-customisation textarea:not([disabled])')]
      .some(fieldHasValue);
  };

  const setButtonText = (label, text) => {
    if (label.textContent.trim() !== text.trim()) {
      label.textContent = text;
    }
  };

  const updateSubmitLabel = (form) => {
    const customisation = form.querySelector(selectors.customisation);
    if (!customisation) return;

    const submit = form.querySelector(selectors.addButton);
    const label = submit ? submit.querySelector('span') : null;
    if (!label || submit.disabled) return;

    const price = moneyFromPriceNode();
    const action = hasPersonalisation(form) ? 'Add to cart' : 'Create your card';
    setButtonText(label, price ? `${action} - ${price}` : action);
  };

  const clampQuantity = (form) => {
    const productInfo = form.closest('product-info');
    const input = productInfo?.querySelector(selectors.quantityInput) || document.querySelector(selectors.quantityInput);
    if (!input || input.max !== '1') return;
    input.value = '1';
    input.setAttribute('value', '1');
  };

  const clearCustomisation = (form) => {
    form.querySelectorAll('.ppv2-customisation input, .ppv2-customisation textarea').forEach((field) => {
      field.value = '';
    });
    hideValidationMessage(form);
    updateSubmitLabel(form);
  };

  const updateCartBubble = async () => {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;

    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;

    const cart = await response.json();
    let bubble = cartIcon.querySelector('.cart-count-bubble');

    if (cart.item_count < 1) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      cartIcon.appendChild(bubble);
    }

    const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
    const hiddenCount = bubble.querySelector('.visually-hidden');
    if (visibleCount) visibleCount.textContent = cart.item_count;
    if (hiddenCount) hiddenCount.textContent = `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`;
  };

  const showCheckout = async (form) => {
    const checkout = form.querySelector(selectors.checkout);
    if (checkout) checkout.hidden = false;
    await updateCartBubble();
  };

  const addToCartWithFetch = async (form) => {
    const formData = new FormData(form);
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error('Cart add failed');
    return response.json();
  };

  const scheduleRefresh = (form) => {
    [50, 350, 900].forEach((delay) => {
      window.setTimeout(() => {
        clampQuantity(form);
        updateSubmitLabel(form);
      }, delay);
    });
  };

  const bindForm = (form) => {
    const customisation = form.querySelector(selectors.customisation);
    form.enctype = 'multipart/form-data';
    if (!customisation) return;

    updateCustomisationGroups(customisation);
    clampQuantity(form);
    updateSubmitLabel(form);

    document.addEventListener('change', () => {
      updateCustomisationGroups(customisation);
      hideValidationMessage(form);
      scheduleRefresh(form);
    });

    document.addEventListener('variant:change', () => {
      updateCustomisationGroups(customisation);
      scheduleRefresh(form);
    });

    document.addEventListener('variant:changed', () => {
      updateCustomisationGroups(customisation);
      scheduleRefresh(form);
    });

    form.addEventListener('input', () => {
      hideValidationMessage(form);
      updateSubmitLabel(form);
    });

    form.addEventListener('change', () => {
      hideValidationMessage(form);
      updateSubmitLabel(form);
    });

    const productInfo = form.closest('product-info');
    const quantityInput = productInfo?.querySelector(selectors.quantityInput) || document.querySelector(selectors.quantityInput);
    if (quantityInput) {
      quantityInput.addEventListener('input', () => clampQuantity(form));
      quantityInput.addEventListener('change', () => clampQuantity(form));
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (!validatePersonalisation(form)) {
        showValidationMessage(form);
        return;
      }

      try {
        await addToCartWithFetch(form);
        clearCustomisation(form);
        await showCheckout(form);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {
        form.submit();
      }
    }, true);
  };

  const init = () => {
    document.querySelectorAll(selectors.form).forEach(bindForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();